<template>
  <!-- <div id="navbar"> -->
  <b-navbar id="navbar">
          <template #brand>
              <b-navbar-item tag="router-link" :to="{ path: '/' }">
                  <img
                      class="logo-kontraola"
                      src="@/assets/images/navBar/logo_kontraola_white.svg"
                      alt="logo kontraola panel_container"
                  >
              </b-navbar-item>
          </template>

          <template #start>
            
          </template>

          <template #end>

            <div id="navBar-start" class="is-flex is-align-items-center navBar-start">
              <router-link
               class="white is-size-extra-text montserrat-medium"
               :to="{ name: 'CampamentosActivos'}">
               Campamentos</router-link> 
              <router-link
               class="white is-size-extra-text ml-4 montserrat-medium"
               :to="{ name: 'CursosActivos'}">
               Clases</router-link> 
              <router-link
                class="white is-size-extra-text ml-3 montserrat-medium"
                :to="{ name: 'MisPerfiles'}">
                Perfiles</router-link>
              <router-link
                class="white is-size-extra-text ml-3 montserrat-medium"
                :to="{ name: 'MisBonos'}">
                Bonos</router-link>
            </div>

            <div class="buttons-nav is-flex is-align-items-center">
                <button
                  class="mr-5 button-stroke-orange add-student"
                  @click.prevent="newprofile">
                  + Nuevo estudiante</button>

                <div
                  @click="$store.commit('openModal', 'addcredits')" 
                  class="money">
                  <span
                    class="montserrat-medium white">EUR {{ Math.round(($store.state.user.credits + Number.EPSILON) * 100) / 100 }}</span>
                </div>
              </div>
              
              <div class="avatar_navbar mt-1">
                <!-- avatar -->
                <figure
                  @click="showMenu" class="
                  ml-5
                  pt-1
                  image-
                  is-hidden-touch
                  is-flex">
                  <img
                    class="is-rounded image-avatar-panel"
                    :src="$store.getters.avatar"
                    width=38 >
                  <img
                    class="arrow-avatar-nav-bar is-align-self-flex-end"
                    src="@/assets/images/navBar/arrow.svg"
                    alt="">
 
                  <div class="circle-available"></div>

                  <!-- <div v-if="showp === true && approved === true" class="circle-available"></div>
                  <div v-else-if="showp === true && approved === false" class="circle-review"></div>
                  <div v-else class="circle-disable"></div> -->
                </figure>
              </div>

              <!-- avatar options box -->
              <div
                id="menu_logout_mobile"
                class="disp-none btn-logout">
                <div
                  @click="$store.commit('openModal', 'addcredits')" 
                  class="money_mobile is-flex is-align-items-center">
                  <img class="mr-2 img-eur" src="@/assets/images/navBar/euro.svg" alt="euro">
                  <span
                    class="button span-eur is-light montserrat-semibold black">EUR {{ Math.round(($store.state.user.credits + Number.EPSILON) * 100) / 100 }}</span>
                </div>
                <div
                  class="is-flex is-align-items-center">
                  <img class="mr-2 img-logout" src="@/assets/images/navBar/logout.svg" alt="logout">
                  <a @click.prevent="logout" class="button is-light montserrat-semibold black">
                      Salir
                  </a>
                </div>
                <!-- link gray -->
                  <div class="line-gray mt-3"></div>
                <div
                  @click="$store.commit('openModal', 'addcredits')" 
                  class="montserrat-semibold black mt-4 pb-5 refill">
                    Recargar saldo
                </div>
              </div>
          </template>

      </b-navbar>

</template>

<script>
  import firebase from 'firebase/compat/app'
  import 'firebase/compat/auth'

  export default {
    name: 'NavBar',
      components: {
      },
      data () {
        return {
        }
      },
      methods: {
        // Logout
        async logout() {
          // console.log('oio')
          await firebase.auth().signOut()
          this.$router.push('/').catch(()=>{})
        },
        showMenu () {
          document.getElementById('menu_logout_mobile').classList.toggle('disp-none')
        },
        // New Profile
        newprofile () {
          this.$store.commit('openModal', 'newprofile')
        },

      }

  }
</script>

<style lang="scss" scoped>
.span-eur {
  font-size: 13.5px;
}

#nav-general {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #ffffff;
    }
  }
}

.navBar-general {
  width: 604px;
  display: flex;
  justify-content: space-between;
 
}

.img-logout {
  width: 24px;
}

.img-eur {
  width: 17px;
}

.refill {
  font-size: 13.5px;
}

#navbar {
  display: flex;
  padding: 0 25px;
  height: 65px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #000;
  justify-content: space-between;
  align-items: center;
  z-index: 4;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#navBar-start {
  margin-right: 260px;
  margin-top: 4px;
  
}

#navBar-start a {
  color: rgba(255, 255, 255, 0.6) !important;
  font-size: 14px;
  font-family: "Montserrat Medium";
}

#navBar-start a.router-link-exact-active {
  font-family: "Montserrat Bold";
  font-size: 14px !important;
  color: rgba(255, 255, 255, 1) !important;
}

#chance_password .label,
#chance_password input::placeholder {
  color: #555!important;
}

.image-avatar-panel {
  width: 23px;
  height: 23px;
  object-fit: cover;
  border-radius: 30px;
}

.circle-available {
  width: 8px;
  height: 8px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #00D6CB;
  position: absolute;
  top: 18px;
  right: 29px;
  /* border: 2px solid; */
}

.circle-review {
  width: 8px;
  height: 8px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #ff9100;
  position: absolute;
  top: 10px;
  right: 25px;
}

.circle-disable {
  width: 8px;
  height: 8px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #FF1515;
  position: absolute;
  top: 4px;
  right: 27px;
  /* border: 2px solid; */
}

.line-gray {
  border-top: 1px solid #ECECEC;
  height: 3px;
  width: 80%;
}

.arrow-avatar-nav-bar {
  width: 8px;
  height: 7px;
}

.resetPasswordModal {
  display: none;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
}

.menu-my-profile {
  visibility: hidden;
}

.button {
  background-color: #fff !important;
}

.item-menu img {
  width: 20px;
}

.logout {
  float: right;
  margin-right: -9px;
  margin-top: -4px;
  padding-left: 26px;
  width: 40px;
}

.disp-none {
  display: none!important;
}

.btn-logout {
  top: 57px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 54px;
  position: absolute;
  right: 15px;
  width: 257px;
  background-color: #fff;
  box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.btn-logout a {
  background-color: #fff;
  color: #000;
  font-size: 13.5px;
}

.title-header-section-create-account {
  margin-top: 73px;
  margin-left: 5%;
}

.form-login {
  margin-top: 70px;
}

.container-content-create-account {
  width: 85%;
}

.position-fixed {
  position: fixed!important;
}

.position-abosolute {
  position: absolute!important;
}

form {
  width: 90%;
  margin: auto;
  max-width: 360px;
}

.label:not(:last-child) {
  margin-bottom: 0.3em !important;
}

.money {
  margin-right: 15px;
}

@media only screen and (max-width: 1023px) {
  .navbar-brand .navbar-item {
    display: none;
  }
  .is-hidden-touch {
    display: block !important;
  }
}

@media only screen and (max-width: 638px) {
  .logo-kontraola {
    display: none;
  }

  #navBar-start {
    margin-right: 6px;
  }

  #navBar-start a {
    font-size: 13px;
    font-family: "Montserrat";
  }

  #navBar-start a.router-link-exact-active {
    font-family: "Montserrat Bold";
    font-size: 13px !important;
    
  }

  .money {
    display: none;
  }

  .add-student {
    display: none;
  }

  .money {
    margin-right: 2px;
    font-size: 14px;;
  }

  #navbar {
    padding: 0 18px;
  }

  .circle-available {
    top: 23px;
    right: 20px;
  }
}



@media (min-width: 1024px) {
  .btn-logout {
    top: 56px;
  }
}

@media (max-width: 1024px) {

  .visiting-profile {
    width: 100%!important;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    /* position: absolute!important; */
  }
  .visiting-profile-w {
    width: 100%!important;
  }
}

</style>